<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  formatServerClock,
  msUntilNextServerSecond,
} from 'dashboard/helper/serverClock';

const { t } = useI18n();
const label = ref('');
let timer = 0;

const paint = () => {
  const next = formatServerClock();
  if (next !== label.value) label.value = next;
};

const arm = () => {
  paint();
  timer = window.setTimeout(arm, msUntilNextServerSecond());
};

const stop = () => {
  window.clearTimeout(timer);
  timer = 0;
};

const onVisibility = () => {
  if (document.hidden) {
    stop();
    return;
  }
  if (!timer) arm();
};

onMounted(() => {
  arm();
  document.addEventListener('visibilitychange', onVisibility);
});

onBeforeUnmount(() => {
  stop();
  document.removeEventListener('visibilitychange', onVisibility);
});
</script>

<template>
  <span
    class="inline-block w-[4.5rem] shrink-0 text-sm tabular-nums text-n-slate-11"
    :title="label ? t('HEADER.SERVER_TIME') : undefined"
  >
    {{ label }}
  </span>
</template>
